module.exports = new __parcel__URL__("Sample.1d07259a.csv").toString();